import { render } from "./StudyDetails.vue?vue&type=template&id=3eded92b&scoped=true"
import script from "./StudyDetails.vue?vue&type=script&lang=js"
export * from "./StudyDetails.vue?vue&type=script&lang=js"

import "./StudyDetails.vue?vue&type=style&index=0&id=3eded92b&lang=scss&scoped=true"
import "./StudyDetails.vue?vue&type=style&index=1&id=3eded92b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eded92b"]])

export default __exports__